import { FavoriteIcon } from '@/components';
import { ButtonOutlineSmall, ButtonPrimarySmall } from '@/design-system';
import colors from '@/theme/colors';
import { css, cx } from '@emotion/css';
import React, { useState } from 'react';

interface FollowButtonProps {
  onClick?: () => void;
}

export const FollowButton: React.FC<FollowButtonProps> = ({ onClick }) => {
    const [isFollowing, setIsFollowing] = useState(false);

    const handleClick = () => {
        setIsFollowing(!isFollowing);
        onClick?.();
    }

    const Button = isFollowing ? ButtonOutlineSmall : ButtonPrimarySmall;

    return (
        <Button
            aria-label={`${isFollowing ? 'Unfollow' : 'Follow'} Organization`}
            onClick={handleClick}
            className={cn.button}
        >
            <FavoriteIcon isFavorite={isFollowing} size={22} color={colors.white} />
            {isFollowing ? 'Following' : 'Follow'}
        </Button>
    )
};

const cn = {
    button: css`
        gap: 8px !important;
    `,
}